
/**
 * Utilities for interacting with localStorage
 */
import { toast } from "sonner";
import { forceFullRefresh } from "./refreshUtils";

/**
 * Clear localStorage items, preserving only essential data
 */
export function clearLocalStorage(): void {
  Object.keys(localStorage).forEach(key => {
    if (!key.includes('supabase.auth') && 
        !key.includes('feature-config') && 
        !key.includes('theme') && 
        !key.includes('sidebar')) {
      localStorage.removeItem(key);
    }
  });
}

/**
 * Clear sessionStorage items, preserving auth
 */
export function clearSessionStorage(): void {
  Object.keys(sessionStorage).forEach(key => {
    if (!key.includes('supabase.auth')) {
      sessionStorage.removeItem(key);
    }
  });
}

/**
 * Set cache control headers in sessionStorage for fetch requests
 */
export function setCacheControlHeaders(): void {
  sessionStorage.setItem('cache-control-headers', JSON.stringify({
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }));
}

/**
 * Utility to check if the app should reload due to version changes
 * This can be called on app init to check for new versions
 */
export function checkVersionAndReload(): void {
  // Get build date from window.__BUILD_DATE__ instead of process.env
  const buildDate = window.__BUILD_DATE__;
  const cachedBuildDate = localStorage.getItem('app_build_date');
  
  if (buildDate && cachedBuildDate && buildDate !== cachedBuildDate) {
    console.log(`New version detected. Current: ${cachedBuildDate}, New: ${buildDate}`);
    toast.info("New version available", {
      description: "Reloading to get the latest updates...",
      duration: 3000,
    });
    
    // Update stored build date
    localStorage.setItem('app_build_date', buildDate);
    
    // Reload after a short delay
    setTimeout(() => forceFullRefresh(), 3000);
  } else if (buildDate) {
    // Store current build date for future comparison
    localStorage.setItem('app_build_date', buildDate);
  }
}
